import shiftsSlice from './shifts';


export default {
  shiftsSlice,
  
};
